/* ══════════════════════════════════════════
   MARVRECO — Custom Theme JS
══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Scroll Reveal ── */
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el, i) {
    el.style.transitionDelay = (i % 6 * 0.07) + 's';
    io.observe(el);
  });

  /* ── Nav shadow on scroll ── */
  var nav = document.getElementById('marv-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.style.boxShadow = window.scrollY > 12 ? '0 2px 24px rgba(12,28,69,0.09)' : '';
    }, { passive: true });
  }

  /* ── Mobile hamburger ── */
  var hamburger = document.getElementById('navHamburger');
  var mobileMenu = document.getElementById('navMobile');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

});

/* ── Scroll tracking (added 2026-10-12) ──
   Sends Google Analytics events as a visitor moves down a page:
   scroll_25, scroll_50, scroll_75, scroll_100 on every page, and on product pages
   one "seen_<heading>" event the first time each story section comes into view.
   The depth is in the event name so it shows in reports without extra setup. */
(function () {
  var sent = {};
  function send(name) {
    if (sent[name] || typeof window.gtag !== 'function') return;
    sent[name] = true;
    window.gtag('event', name, { page_path: location.pathname });
  }
  function onScroll() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    var pct = (window.scrollY / max) * 100;
    [25, 50, 75, 100].forEach(function (m) { if (pct >= m - 0.5) send('scroll_' + m); });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });

  function slug(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').split('_').slice(0, 4).join('_').slice(0, 34);
  }
  function watchSections() {
    if (!('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('main .pdp-sec, main .pdp-banner');
    if (!sections.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var h = e.target.querySelector('h2');
        if (h && h.textContent.trim()) send('seen_' + slug(h.textContent));
        io.unobserve(e.target);
      });
    }, { threshold: 0.35 });
    sections.forEach(function (s) { io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSections);
  else watchSections();
})();
